import React from 'react';
import PropTypes from 'prop-types';

const Exclamation = ({ color = '#00adef', ...props }) => (
  <svg width={14} height={14} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M7 .333a6.667 6.667 0 1 0 0 13.334A6.667 6.667 0 0 0 7 .333Zm.505 10.195a.505.505 0 1 1-1.01 0V6.49a.505.505 0 1 1 1.01 0v4.038ZM7 4.845a.853.853 0 1 1 .01 0H7Z"
      fill={color}
    />
  </svg>
);

Exclamation.propTypes = {
  color: PropTypes.string
};

export default Exclamation;
